import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=ae4f1dd0&scoped=true&"
import script from "./Help.vue?vue&type=script&lang=js&"
export * from "./Help.vue?vue&type=script&lang=js&"
import style0 from "./Help.vue?vue&type=style&index=0&id=ae4f1dd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4f1dd0",
  null
  
)

export default component.exports